/**
 * Toaster wrapper — uses the app's custom ThemeContext (not next-themes).
 *
 * The shadcn/ui default imports `useTheme` from "next-themes", but this app
 * uses a custom ThemeProvider in contexts/ThemeContext.tsx. Mixing the two
 * caused React Error #185 on fresh loads because next-themes' useTheme()
 * was called without its required <ThemeProvider> in the tree, leading to
 * a context subscription loop in production React.
 */
import { useTheme } from "@/contexts/ThemeContext";
import { Toaster as Sonner, type ToasterProps } from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)",
        } as React.CSSProperties
      }
      {...props}
    />
  );
};

export { Toaster };
